// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IntellicheckUploadComponentBase } from '../intellicheck-upload-component-base';
import { IntellicheckUploadStep } from '../intellicheck-upload-step';
import { ErrorService } from '@services/error.service';
import { IDScanResult, RequestedScanType } from '../id-scan-logging';
import { NavigationStart, Router } from '@angular/router';
import { filter, takeWhile } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-intellicheck-license-selfie',
    templateUrl: './intellicheck-license-selfie.component.html',
    styleUrls: ['../intellicheck-upload.component.scss'],
})
export class IntellicheckLicenseSelfieComponent extends IntellicheckUploadComponentBase implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('uploadPreview') previewCanvas: ElementRef<HTMLCanvasElement>;
    @ViewChild('manualInput') fileInputElement: ElementRef<HTMLInputElement>;
    private previewCanvasContext: CanvasRenderingContext2D;

    protected moduleElementName = 'idn-facial-recognition';
    protected moduleName = 'IDN-FacialRecognition-003';
    protected imageDataFieldName = 'selfieImage';
    private startScanTime: Date;
    private isComponentAlive = true;
    private base64Image: string = null;

    constructor(
        private readonly errorService: ErrorService,
        private readonly dialog: MatDialog,
        private readonly router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.partialLoading.emit();
        this.doneLoading.emit();
        this.step = IntellicheckUploadStep.Begin;
    }

    ngAfterViewInit(): void {
        this.isComponentAlive = true;
        this.step = IntellicheckUploadStep.Begin;
        this.subscribeToNavigation();
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }

    onImageCapture(overrideImage: File) {
        this.pushScanResults(IDScanResult.Success);
        this.displayUploadPreview(overrideImage);
    }

    displayUploadPreview(imageFile: File) {
        const canvas = this.previewCanvas.nativeElement;
        const image = new Image();
        this.step = IntellicheckUploadStep.Preview;
        const reader = new FileReader();
        reader.onload = (event) => {
            const dataString = event.target.result as string;
            image.src = dataString;
            this.base64Image = dataString.split(',')[1];
        };
        reader.readAsDataURL(imageFile);

        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            canvas.style.maxWidth = image.width.toString() + 'px';
            if (!this.previewCanvasContext) {
                this.previewCanvasContext = canvas.getContext('2d');
            }
            this.previewCanvasContext.drawImage(image, 0, 0, image.width, image.height);
        };
    }

    startCapture() {
        this.startScanTime = new Date();
        this.fileInputElement.nativeElement.click();
    }

    continue() {
        this.captureComplete.emit({ selfieImage: this.base64Image });
    }

    recapture() {
        this.step = IntellicheckUploadStep.Begin;
        this.base64Image = null;
    }

    pushScanResults = (result: IDScanResult) => {
        this.logScanAtttempt.emit({
            type: RequestedScanType.Selfie,
            typeName: RequestedScanType[RequestedScanType.Selfie],
            moduleName: this.moduleName,
            startTime: this.startScanTime,
            endTime: new Date(),
            elapsedMilliseconds: new Date().getTime() - this.startScanTime.getTime(),
            result: result,
            resultName: IDScanResult[result],
            data: null,
            dealerId: null,
            dealId: null,
            docId: null,
        });
    };

    subscribeToNavigation = () => {
        this.router.events
            .pipe(takeWhile(() => this.isComponentAlive))
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe((event: NavigationStart) => {
                if (event.navigationTrigger === 'popstate') {
                    this.pushScanResults(IDScanResult.BrowserBack);
                }
            });
    };
}
